import React from "react";
import { useTranslation } from "react-i18next";

import usersService from "../../../../services/userService";

import DropDownMenu from "../../DropDownMenu";
import { Button } from "../../Buttons";

function UserDropdown({ userInfo }) {
  const { t } = useTranslation();
  return (
    <DropDownMenu>
      <ul>
        <li className="hasBorderBottom">
          <p>{userInfo?.name}</p>
        </li>
        <li>
          <Button
            label={t("editProfile")}
            iconClassName="hasIcon--edit"
            viewType="noBorder"
            onClick={() =>
              usersService.goToMonolith(`accounts/readers/${userInfo?.id}/`)
            }
          />
        </li>
        <li>
          <Button
            label={t("goToParent")}
            iconClassName="hasIcon--log-out"
            viewType="noBorder"
            onClick={() => usersService.goToMonolith("hijack/release-hijack/")}
          />
        </li>
      </ul>
    </DropDownMenu>
  );
}

export default UserDropdown;
